export default {"src":"/_next/static/media/t-mobile.1d6f2975.svg","height":20,"width":20};